// External libraries
import React from 'react';
import { useStoreState } from '@/store';
//@ts-expect-error untyped import
import { CardExpiry as Expiry } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { cardSubFieldsContainerStyleOverrides } from '../styles';
import { formInputHandlers } from '@/components/Form/formInputHandlers';

export const CardExpiry = (): React.ReactElement => {
  useMountLogging('CardExpiry');
  const cardExpiry = useStoreState(({ form }) => form.cardExpiry);
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);

  return (
    <Expiry
      containerStyleOverrides={cardSubFieldsContainerStyleOverrides}
      disabled={isFormSubmitting}
      label={getContent('fieldLabels.expirationLabel')}
      placeholder={getContent('fieldLabels.expirationFormat')}
      {...formInputHandlers}
      {...cardExpiry}
    />
  );
};
